import script from "./ResidentProfileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResidentProfileCard.vue?vue&type=script&setup=true&lang=js"

import "./ResidentProfileCard.vue?vue&type=style&index=0&id=ed8de2c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed8de2c6"]])

export default __exports__